export const DISTRIBUTION_TITLE_CELL_KEY = 'A1';
export const PER_SHARE_TITLE_CELL_KEY = 'B1';
export const DISTRIBUTION_TITLE_LABEL = 'Distribution';
export const PER_SHARE_TITLE_LABEL = 'Per Share';

export const WATERFALL_CALCULATOR_TABLE_NAME = 'Waterfall Calculator';
export const WATERFALL_CALCULATOR_TABLE_SLUG = 'waterfall-calculator';
